module.exports = __webpack_public_path__ + "img/rbe-footer-tablet.9a0665f.svg";